import axios from "./axios.interceptors";

export type Currency = { id: string; code: string; name: string; active?: boolean; enabled?: boolean; status?: string };

class CurrenciesServices {
  fetchAll = async (): Promise<Currency[]> => {
    const res = await axios.get("api/currencies"); 
    return res.data;
  };
}

export default new CurrenciesServices();
